import styled from 'styled-components';

import { FlexContainer } from 'components/FlexContainer';

export const CalculationSummaryContainer = styled(FlexContainer)`
  text-align: center;
`;
